/**
 * Product Image Zoom Lens Effect
 * 实现鼠标移动时的实时放大镜效果
 */
class ProductZoomLens {
  constructor() {
    this.zoomLevel = 2; // 放大倍数
    this.init();
  }

  init() {
    // 查找所有启用缩放的媒体画廊
    const galleries = document.querySelectorAll('.m-media-gallery[data-enable-image-zoom="true"]');

    galleries.forEach(gallery => {
      this.setupGallery(gallery);
    });
  }

  setupGallery(gallery) {
    const mediaItems = gallery.querySelectorAll('.m-product-media--item.media-type-image');

    mediaItems.forEach(item => {
      this.setupMediaItem(item);
    });
  }

  setupMediaItem(mediaItem) {
    const img = mediaItem.querySelector('img.m-image, img');
    if (!img) return;

    // 等待图片加载完成
    if (!img.complete) {
      img.addEventListener('load', () => this.setupZoomLens(img, mediaItem));
    } else {
      this.setupZoomLens(img, mediaItem);
    }
  }

  setupZoomLens(img, mediaItem) {
    // 计算放大镜尺寸为图片尺寸的50%
    const imgWidth = img.offsetWidth || img.naturalWidth;
    const imgHeight = img.offsetHeight || img.naturalHeight;
    const lensWidth = Math.floor(imgWidth * 0.5);
    const lensHeight = Math.floor(imgHeight * 0.5);

    // 创建放大镜元素
    const lens = document.createElement('div');
    lens.className = 'm-zoom-lens';
    lens.style.cssText = `
      position: absolute;
      width: ${lensWidth}px;
      height: ${lensHeight}px;
      border-radius: 0;
      pointer-events: none;
      display: none;
      z-index: 1000;
      background-repeat: no-repeat;
      background-color: #fff;
      overflow: hidden;
    `;

    mediaItem.style.position = 'relative';
    mediaItem.appendChild(lens);

    let isHovering = false;

    // 鼠标进入事件
    mediaItem.addEventListener('mouseenter', (e) => {
      isHovering = true;
      lens.style.display = 'block';

      // 设置放大镜的背景图片
      lens.style.backgroundImage = `url(${img.src})`;
      lens.style.backgroundSize = `${img.width * this.zoomLevel}px ${img.height * this.zoomLevel}px`;
    });

    // 鼠标移动事件
    mediaItem.addEventListener('mousemove', (e) => {
      if (!isHovering) return;

      const rect = mediaItem.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      // 计算放大镜位置（居中显示）
      let lensX = x - lensWidth / 2;
      let lensY = y - lensHeight / 2;

      // 边界检测，防止放大镜超出图片范围
      const maxX = rect.width - lensWidth;
      const maxY = rect.height - lensHeight;

      lensX = Math.max(0, Math.min(lensX, maxX));
      lensY = Math.max(0, Math.min(lensY, maxY));

      lens.style.left = `${lensX}px`;
      lens.style.top = `${lensY}px`;

      // 计算背景图片位置
      const bgX = -(x * this.zoomLevel - lensWidth / 2);
      const bgY = -(y * this.zoomLevel - lensHeight / 2);

      lens.style.backgroundPosition = `${bgX}px ${bgY}px`;
    });

    // 鼠标离开事件
    mediaItem.addEventListener('mouseleave', () => {
      isHovering = false;
      lens.style.display = 'none';
    });

    // 触摸设备支持
    mediaItem.addEventListener('touchstart', (e) => {
      isHovering = true;
      lens.style.display = 'block';
      lens.style.backgroundImage = `url(${img.src})`;
      lens.style.backgroundSize = `${img.width * this.zoomLevel}px ${img.height * this.zoomLevel}px`;
    });

    mediaItem.addEventListener('touchmove', (e) => {
      if (!isHovering) return;
      e.preventDefault();

      const touch = e.touches[0];
      const rect = mediaItem.getBoundingClientRect();
      const x = touch.clientX - rect.left;
      const y = touch.clientY - rect.top;

      let lensX = x - lensWidth / 2;
      let lensY = y - lensHeight / 2;

      const maxX = rect.width - lensWidth;
      const maxY = rect.height - lensHeight;

      lensX = Math.max(0, Math.min(lensX, maxX));
      lensY = Math.max(0, Math.min(lensY, maxY));

      lens.style.left = `${lensX}px`;
      lens.style.top = `${lensY}px`;

      const bgX = -(x * this.zoomLevel - lensWidth / 2);
      const bgY = -(y * this.zoomLevel - lensHeight / 2);

      lens.style.backgroundPosition = `${bgX}px ${bgY}px`;
    });

    mediaItem.addEventListener('touchend', () => {
      isHovering = false;
      lens.style.display = 'none';
    });
  }
}

// 初始化
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductZoomLens();
  });
} else {
  new ProductZoomLens();
}

// 当Swiper切换幻灯片时重新初始化
document.addEventListener('DOMContentLoaded', () => {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            const gallery = node.querySelector?.('.m-media-gallery[data-enable-image-zoom="true"]');
            if (gallery) {
              new ProductZoomLens();
            }
          }
        });
      }
    });
  });

  const observerTarget = document.querySelector('.m-main-product--wrapper');
  if (observerTarget) {
    observer.observe(observerTarget, {
      childList: true,
      subtree: true
    });
  }
});
